module.exports = __webpack_public_path__ + "static/media/Phone.6d9b25b4.png";